/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, Highcharts, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';

  var name_normalizer = {
    'samsung': `Samsung`,
    'Samsung': `Samsung`,
    'LGE': `LGE`,
    'lge': `LGE`,
    'Sony Ericsson': `Sony`,
    'Sony': `Sony`,
    'HTC': `HTC`,
    'htc': `HTC`,
    'Motorola': `Motorola`,
    'motorola': `Motorola`,
    'asus': `Asus`,
    'Amazon': `Amazon`,
  };

  ns.AndroidManufacturer = mp.marketing.trends.widgets.TrendReport.extend({
    get_queries() {
      var date_range = this.session.get(`date_range`);
      return {
        base: {
          'query_name': `android_manufacturer`,
          'from_date': date_range.from().toString(mp.utility.default_date_format),
          'to_date': date_range.to().toString(mp.utility.default_date_format),
        },
      };
    },

    get_chart_params(query_data) {
      var data = _.extend({}, query_data.base);
      var total_count = _.reduce(data, function(memo, dates, segment) {
        var n = _.reduce(dates, function(m, v) { return m + v; }, 0);
        data[segment] = n;
        return memo + n;
      }, 0);

      var normalized_data = {};
      _.each(data, function(count, segment) {
        if (segment === `unknown`) { return; }
        if (_.has(name_normalizer, segment)) {
          var normalized_segment = name_normalizer[segment];
          normalized_data[normalized_segment] = (normalized_data[segment] || 0) + count;
        } else {
          normalized_data.Other = (normalized_data.Other || 0) + count;
        }
      });

      var top_segments = this._top_n_segments(normalized_data, 100);
      var chart_data = _.map(top_segments, function(segment, i) {
        var percent = (normalized_data[segment] / total_count) * 100;
        return {
          'name': segment,
          'y': percent ? percent : 0,
          'color': mp.charts.nth_color(i),
        };
      });

      return {
        'chart': {
          'marginTop': 20,
        },
        'xAxis': {
          'categories': top_segments,
          'type': `linear`,
        },
        'yAxis': {'labels': {'formatter'() { return this.value + `%`; }}},
        'series': [{'data': chart_data, 'type': `column`}],
        'tooltip': {
          'backgroundColor': `rgba(255, 255, 255, 1)`,
          'borderWidth': 1,
          'useHTML': false,
          'formatter'() {
            var n = Highcharts.numberFormat(this.y, 2) + `%`;
            return `<b>`+ mp.utility.sanitize(this.point.name || this.series.name) +`</b>: `+
                            `<div style="text-align: right">` + n + `</div>`;
          },
        },
      };
    },

    getDownloadName() {
      return ns.AndroidManufacturer.nice_name;
    },
  });

  // used by the data_viewer to render pretty dropdowns and stuff
  ns.AndroidManufacturer.slug = `android_manufacturer`;
  ns.AndroidManufacturer.nice_name = `Android manufacturers`;
  ns.AndroidManufacturer.description = `What device manufacturers have the largest share of the Android OS market?`;
  ns.AndroidManufacturer.asterisk = `The Other bar is an aggregate of all other Android device manufacturers.`;
  ns.AndroidManufacturer.chart_type = `bar`;
});

}.call(window));